import { type FC, useContext, useState } from 'react';

import { useStorePrice } from '@/common/hooks/apple-price';
import { type Reward } from '@/common/types/earnRewardsType';
import { ModalContext } from '@/components/Modals/Modal/config';
import { MainButton } from '@/components/ui/Button/Button';

import PlanCalendar from './PlanCalendar';
import PlanOverview from './PlanOverview';

interface BuyPaidPlanProps {
  rewards?: Reward[];
  cost: {
    amountUsd: number;
    amountStars: number;
  };
}

const BuyPaidPlan: FC<BuyPaidPlanProps> = ({ rewards, cost }) => {
  const [tab, setTab] = useState(0);
  const { openModal } = useContext(ModalContext);
  const storePrice = useStorePrice(cost.amountUsd);

  return (
    <>
      {tab === 0 ? (
        <PlanOverview rewards={rewards} nextTab={() => setTab(1)} />
      ) : (
        <PlanCalendar prevTab={() => setTab(0)} rewards={rewards} />
      )}

      <div className="mt-auto pb-[calc(var(--tg-safe-area-inset-bottom,0px)+1rem)] w-full px-8">
        <MainButton
          onClick={() =>
            openModal({ renderKind: 'buyPaidRewardLine', props: undefined })
          }
          text={storePrice ?? `$ ${cost.amountUsd}`}
        />
      </div>
    </>
  );
};

export default BuyPaidPlan;
